module.exports = __webpack_public_path__ + "images/480b8d17efb9de0c64a5c907fca1a1e2f.svg";